<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.docflowRegister') }}</h1>
      <div class="form-container">
        <DocflowRegisterForm @save="save"></DocflowRegisterForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import DocflowRegisterForm from '@/components/DocflowRegisterForm'
  import {mapState} from 'vuex'

  export default {
    components: {
      DashboardLayout,
      DocflowRegisterForm
    },
    methods: {
      save(documentForm) {
        this.$store.dispatch('Docflow/register', {
          ...documentForm,
          id: this.$route.params.documentId
        }).then(({document_id}) => {
          this.$router.push({
            name: this.detail.category === 'appeal' ? 'docflowAppealDetail' : 'docflowIncomingDetail',
            params: {documentId: document_id}
          })
        })
      }
    },
    mounted() {
      this.$store.dispatch('Docflow/getRelations', {
        category: this.detail.category === 'outgoing' ? 'incoming' : this.detail.category,
        documentId: null
      })
    },
    computed: {
      ...mapState('Docflow', ['detail']),
      breadcrumbs() {
        return [
          { name: 'docflow', path: 'docflow' },
          { name: 'docflowRegister' }
        ]
      }
    }
  }
</script>
